import * as React from "react";

import { cn } from "../../utils/cn";

interface SkeletonProps extends React.HTMLAttributes<HTMLElement> {
    surface?: "light" | "dark";
    inline?: boolean;
}

function Skeleton({
    className,
    surface = "light",
    inline = false,
    ...props
}: SkeletonProps): React.ReactElement {
    const bg =
        surface === "dark"
            ? "bg-surface-skeleton-inverse"
            : "bg-surface-skeleton-base";
    const base = cn("animate-pulse rounded-sm", bg, className);

    if (inline) {
        return (
            <span
                data-slot="skeleton"
                data-surface={surface}
                aria-hidden="true"
                className={cn("inline-block align-middle", base)}
                {...props}
            />
        );
    }
    return (
        <div
            data-slot="skeleton"
            data-surface={surface}
            aria-hidden="true"
            className={base}
            {...(props as React.HTMLAttributes<HTMLDivElement>)}
        />
    );
}

export { Skeleton };
